import { db, docsFromSnapshot, docFromSnapshot } from "../../firebase";
import _ from "lodash";

export const DEFAULT_CUSTOMER = {
  companyName: null,
  emailAddress: null,
  vatNumber: null,
  contactName: null,
  contactNumber: null,
  address: {
    line1: null,
    line2: null,
    district: null,
    region: null,
    postcode: null
  },
  notes: null,
  customerStatements: {
    enabled: true
  },
  paymentReminders: {
    enabled: true
  }
};

const state = {
  customers: {},
  targetCustomer: null
};

const getters = {
  customers: state => _.values(state.customers),
  targetCustomer: state => state.targetCustomer
};

const actions = {
  async fetchCustomers({ commit, getters }) {
    const snapshot = await db
      .collection("customers")
      .where("tenantId", "==", getters.tenantId)
      .where("deleted", "==", false)
      .get();
    commit("setCustomers", docsFromSnapshot(snapshot));
  },
  async addCustomer({ commit, getters }, customer) {
    const ref = await db.collection("customers").doc();

    customer = {
      ...customer,
      _id: ref.id,
      tenantId: getters.tenantId,
      deleted: false
    };

    await db
      .collection("customers")
      .doc(ref.id)
      .set(customer);

    commit("setCustomer", customer);

    return customer;
  },
  async fetchCustomer({ commit }, id) {
    const snapshot = await db
      .collection("customers")
      .doc(id)
      .get();

    const customer = docFromSnapshot(snapshot);

    if (!customer.deleted) {
      commit("setCustomer", customer);
    }
  },
  async updateCustomer({ commit }, { id, customer }) {
    await db
      .collection("customers")
      .doc(id)
      .set(customer);

    commit("setCustomer", customer);
  },
  async deleteCustomer({ dispatch, commit }, id) {
    await db
      .collection("customers")
      .doc(id)
      .update({ deleted: true });

    dispatch("fetchCustomers");
    commit("resetCustomer");
  }
};

const mutations = {
  setCustomers(state, customers) {
    state.customers = customers;
  },
  setCustomer(state, customer) {
    state.customers[customer._id] = customer;
    state.targetCustomer = customer;
  },
  resetCustomer(state) {
    state.targetCustomer = null;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};
